module.exports = __webpack_public_path__ + "img/ascenti-physio-logo-white.0deeb86e.png";